<template>
  <div class="banner">
    <section id="banner">
      <div class="inner">
        <p>Découvrez toutes les fonctionnalités</p>
        <h1>PLAYER DEMO</h1>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'banner'}
</script>


// WEBPACK FOOTER //
// Banner.vue?ee055aa4